export enum LoginAnalyticsMessages {
  capability = 'alerts',
  pageName = 'us foods:r4:create new account',
  pageLoadedEvent = 'page loaded',
  newUserSignupEvent = 'new user sign up',
}
